export const KeywordsListsDashboardCss = {
  paperProps: {
    maxHeight: 48 * 4.5,
    width: '20ch'
  },
  tableContainer: {
    border: '1px solid var(--color-border)'
  },
  headerBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline'
  },
  createMenuText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-text-heading)'
  }
};

export const ListDataTableCss = {
  mainBox: {
    border: '1px solid var(--color-border)',
    padding: '0px',
    borderRadius: '8px'
  },
  listName: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'left',
    color: 'var(--color-text-heading)'
  },
  pagination: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    width: '100%'
  },
  selectorBox: {
    display: 'flex',
    gap: '40px',
    marginTop: '24px',
    marginBottom: '24px'
  },
  selectorText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-text-purple)'
  },
  span: {
    fontWeight: 700,
    color: 'var(--color-primary)'
  },
  tableCellHover: {
    '&:hover': {
      cursor: 'pointer' // Change cursor to pointer on hover
    }
  },
  listNameField: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-darkest)'
  },
  keywordField: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-muted)'
  },
  avgKDBox: {
    display: 'flex',
    alignItems: 'center'
  },
  avgKDCircle: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    marginRight: 1
  },
  avgKDText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-muted)'
  },
  addBtnSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  deleteBtnSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-error-bright)'
  },
  menuSx: {
    '&:hover': {
      backgroundColor: 'var(--color-bg-purple-light2)'
    }
  },
  deleteText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-error-bright)',
    cursor: 'pointer'
  },
  rowBoxSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '24px',
    padding: '24px 16px 24px 16px',
    width: '100%',
    backgroundColor: '#FAF9FB',
    marginTop: '10px',
    marginBottom: '10px'
  },
  noKeywordsLists: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'center',
    color: 'var(--color-text-darkest)'
  },
  addIcon: {
    marginRight: '-10px'
  },
  noKeywordsListsDesc: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-mid)'
  },
  rightArrow: {
    cursor: 'pointer'
  },
  snackBarSpan: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    cursor: 'pointer'
  },
  exportBtn: {
    width: 'max-content',
    maxHeight: '40px',
    borderRadius: '4px !important'
  }
};

export const DeleteListModalSx = {
  mainBox: {
    padding: '32px'
  },
  titleSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    color: 'var(--color-primary)',
    textAlign: 'center'
  },
  descSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    textAlign: 'center',
    marginTop: '16px'
  },
  listNameSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)',
    textAlign: 'center',
    marginTop: '4px'
  },
  btnBoxSx: {
    marginTop: '32px',
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    width: '100%'
  },
  cancelBtnSx: {
    maxHeight: '44px',
    padding: '10px 18px 10px 18px',
    gap: '6px',
    borderRadius: '6px',
    border: '1px solid var(--color-text-muted-purple)'
  },
  deleteBtn: {
    maxHeight: '44px',
    padding: '10px 18px 10px 18px',
    gap: '6px',
    borderRadius: '6px'
  },
  cancelBtnText: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-primary)'
  },
  deleteBtnText: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-white)'
  }
};

export const ReNameModalSx = {
  textFieldSx: {
    marginTop: '24px'
  },
  labelTextSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-purple)',
    marginBottom: '6px'
  },
  example: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-tertiary)',
    marginTop: '6px'
  },
  spanSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  titleMargin: {
    marginTop: '-8px'
  }
};

export const CreateListSx = {
  mainBox: {
    maxHeight: '120px', // Adjust height as needed
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    pr: 1,
    '&::-webkit-scrollbar': {
      width: '4px' // Slim scrollbar width
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#B4A7D6', // Optional: light purple tone
      borderRadius: '8px'
    }
  },
  listBoxSx: {
    backgroundColor: 'var(--color-white)',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: 'var(--color-bg-purple-light2)'
    },
    cursor: 'pointer',
    padding: '6px 16px 6px 16px'
  },
  listSubBoxSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  listNameSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  keywordsSx: {
    marginLeft: 2,
    whiteSpace: 'nowrap',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-18)',
    textAlign: 'right',
    color: 'var(--color-text-secondary)'
  },
  loaderBox: {
    height: '120px',
    minWidth: '250px',
    width: '100%',
    alignContent: 'center',
    textAlign: 'center'
  },
  addToKeywordsList: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-purple-deep-alt)'
  },
  addIcon: {
    color: 'var(--color-purple-deep-alt)',
    cursor: 'pointer',
    width: '20px',
    height: '20px'
  },
  addToKeywordsListBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  }
};

export const DeleteMultipleSx = {};

export const FolderDropdownSx = {
  mainBox: {
    border: '1px solid var(--color-border-grey)',
    borderRadius: '6px',
    padding: '10px 12px',
    cursor: 'pointer',
    minWidth: '240px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 'var(--font-size-16)'
  },
  optionBox: {
    px: 2,
    py: 1,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'var(--color-bg-grey)'
    }
  },
  selectedOptionText: {
    fontSize: 'var(--font-size-16)',
    fontWeight: 400
  }
};
